import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../../utils/cn';

const kbdVariants = cva(
  'hidden md:inline-flex shrink-0 justify-center items-center rounded-md font-medium',
  {
    variants: {
      variant: {
        default: 'bg-muted text-foreground-subtle',
        dark: 'bg-white/20 text-inherit',
        ghost: 'bg-transparent !text-foreground-subtle',
      },
      size: {
        sm: 'px-1.5 py-0.5 text-xxs',
        md: 'px-2 py-1 text-xxs',
        lg: 'px-2.5 py-1.5 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'sm',
    },
  },
);

export interface KbdProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof kbdVariants> {
  keyLabel: ReactNode;
}

const Kbd = forwardRef<HTMLElement, KbdProps>(
  ({ keyLabel, variant, size, className, ...props }, ref) => (
    <kbd ref={ref} className={cn(kbdVariants({ variant, size }), className)} {...props}>
      {keyLabel}
    </kbd>
  ),
);

export { Kbd, kbdVariants };
